<div class="copy-order-dialog-container">
    <div class="Order-dialog-header-container">
        <div>  <p class="copy-order-dialog-header-text copy-orders-section-headers">COPY ORDER</p></div>
        <div><p class="copy-order-dialog-sub-heading">Do you want to make a copy of this order?</p></div>
    </div>

<form [formGroup]="copyOrderForm">
    <div class="sold-to-dropdown-container">
        <mat-form-field class="copy-order-dropdownn" appearance="outline">
            <mat-label class="custom-label" appRemoveAriaOwns>Select Client</mat-label>
            <mat-select formControlName="soldToId" #singleSelect>
                <mat-option style="background-color: white!important; padding: 6px!important">
                    <div class="select-search-container-max">
                      <div class="select-search-lrg">
                <ngx-mat-select-search placeholderLabel="Search Client" [formControl]="soldToFilterCtrl">
                    <span ngxMatSelectNoEntriesFound>
                        No entries found
                    </span>
                </ngx-mat-select-search>
            </div>
        </div>
              </mat-option>
        
              <mat-option *ngFor="let customer of filteredSoldTos | async | orderBy: 'name'" [value]="customer.id" [disabled]="customer.isDeleted" (click)="setSelectedSoldTo(customer);" (selectionChange)="null">
                {{customer.ysapCode}} - {{customer.name}}
              </mat-option>
            </mat-select>
            <mat-error
                *ngIf="copyOrderForm.get('soldToId').invalid && copyOrderForm.get('soldToId').touched"
                class="error-notice">
                <strong class="item-required-text">Required* - </strong> Select a sold to
            </mat-error>
        </mat-form-field>
    </div>


    <div class="payer-client-select-container">
        <div class="payer-dropdown-container">
            <mat-form-field class="copy-order-dropdownn" appearance="outline">
                <mat-label class="custom-label" appRemoveAriaOwns>Select Payer</mat-label>
                <mat-select formControlName="payerId" #singleSelect>
                    <mat-option style="background-color: white!important; padding: 6px!important">
                        <div class="select-search-container-max">
                          <div class="select-search-lrg">
                    <ngx-mat-select-search placeholderLabel="Search Payer" [formControl]="payerFilterCtrl">
                        <span ngxMatSelectNoEntriesFound>
                            No entries found
                        </span>
                    </ngx-mat-select-search>
                </div>
            </div>
                  </mat-option>
            
                  <mat-option *ngFor="let customer of filteredPayers | async | orderBy: 'name'" [value]="customer.id" [disabled]="customer.isDeleted" (click)="setSelectedPayer(customer)" (selectionChange)="null">
                    {{customer.ysapCode}} - {{customer.name}}
                  </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="copyOrderForm.get('payerId').invalid && copyOrderForm.get('payerId').touched"
                    class="error-notice">
                    <strong class="item-required-text">Required* - </strong> Select a payer
                </mat-error>
            </mat-form-field>
        </div>


    </div>



    <div class="copy-order-btn-dialog-container">

        <button class="cancel-copy-order-dialog-btn" mat-flat-button type="button" (click)="cancelCopyingOrder()">
            <div class="cancel-copy-order-btn-content">
                <span><p class="cancel-copy-order-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="copy-order-btn" mat-flat-button type="button"
                (click)="copyOrder()">
            <div class="copy-order-btn-content">
                <span><p class="copy-order-btn-text">COPY ORDER</p></span>
            </div>
        </button>
    </div>
</form>
</div>

